import { OrganizationFilter, OrganizationOrdering, QueryOrganizationsArgs } from 'gql-types';

/********************
 * Organization Types
 ********************/
export namespace Organization {
    /** @deprecated Use OrganizationFilter imported from 'gql-types' */
    export type Filters = OrganizationFilter;
    /** @deprecated Use OrganizationOrdering imported from 'gql-types' */
    export type Ordering = OrganizationOrdering;
    /** @deprecated Use QueryOrganizationsArgs imported from 'gql-types' */
    export type ListVariables = QueryOrganizationsArgs;
}

/** Dashboard Configuration */
/** @deprecated Use DashboardVariation imported from 'gql-types' */
export enum DashboardVariation {
    HOSPICE_DEMO = 'HOSPICE_DEMO',
    HOME_HEALTH_DEMO = 'HOME_HEALTH_DEMO',
    ELEANOR_HEALTH = 'ELEANOR_HEALTH',
    JET_HEALTH = 'JET_HEALTH',
    NORTH_STAR = 'NORTH_STAR',
    NORTH_STAR_UAT = 'NORTH_STAR_UAT',
    TELADOC = 'TELADOC',
}

export const DEFAULT_DASHBOARD_VARIATION = DashboardVariation.HOME_HEALTH_DEMO;

/** Syncable Resources */
export enum SyncableResource {
    CLINICIAN = 'CLINICIAN',
    CLINICIAN_APPOINTMENT = 'CLINICIAN_APPOINTMENT',
    EPISODE_OF_CARE = 'EPISODE_OF_CARE',
    ORDER = 'ORDER',
    PATIENT = 'PATIENT',
    VISIT = 'VISIT',
    VISIT_REQUEST = 'VISIT_REQUEST',
}
